import { t } from '@lingui/core/macro'
import { TextThemeUI } from '@jotta/ui/themeui'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'

export interface LeaveAlbumDialogProps extends RadixModalProps {
  isLoading?: boolean
  onLeaveAlbum: () => void
}

export const LeaveAlbumDialog: React.FC<LeaveAlbumDialogProps> = ({
  open = false,
  isLoading = false,
  onClose,
  onLeaveAlbum,
  ...props
}) => {
  return (
    <RadixModal open={open} onClose={onClose} {...props}>
      <RadixDialog
        title={t`LeaveAlbumShareButton.confirmTitle`}
        onClose={onClose}
        buttons={[
          {
            label: t`LeaveAlbumShareButton.confirmLabel`,
            loading: isLoading,
            action: onLeaveAlbum,
            type: 'destructive',
            testId: 'ConfirmLeaveAlbum',
          },
          {
            action: 'close',
            label: t`Cancel`,
            type: 'outline',
          },
        ]}
      >
        <TextThemeUI variant="styles.p" sx={{ mb: 3 }}>
          {t`LeaveAlbumShareButton.confirmBody`}
        </TextThemeUI>
      </RadixDialog>
    </RadixModal>
  )
}
